import React, { Suspense } from "react";
import _Monitor from "../../components/monitor/_Monitor";
import Loading from "../../components/ui/Suspense";
const Monitor = () => {
  return (
    <Suspense fallback={<Loading />}>
      <_Monitor />
    </Suspense>
  );
};

export default Monitor;
